import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import store from '../store'

const request = axios.create({
  baseURL: '/api',
  timeout: 30000
})

request.interceptors.request.use(config => {
  const token = store.state.token
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

request.interceptors.response.use(
  res => {
    if (res.config && res.config.responseType === 'blob') {
      return res
    }
    const data = res.data
    if (data.code !== 200) {
      const msg = data.message || '请求失败'
      Message.error(msg)
      const err = new Error(msg)
      err.code = data.code
      return Promise.reject(err)
    }
    return data
  },
  err => {
    const status = err.response && err.response.status
    const data = err.response && err.response.data
    const serverMsg = data && (data.message || data.msg)
    if (status === 401) {
      store.commit('logout')
      Message.error(serverMsg || '未登录或登录已过期')
      router.push('/login')
      return Promise.reject(err)
    }
    if (!err.response) {
      Message.error('无法连接服务器，请确认后端已启动（localhost:8085）')
      return Promise.reject(err)
    }
    Message.error(serverMsg || ('请求失败' + (status ? '（' + status + '）' : '')))
    return Promise.reject(err)
  }
)

export default request
